module.exports = __webpack_public_path__ + "static/image/font/pc/bmkiranghaerang-1@3x.jpg?b6825f06";